import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment";

import { IEvent } from "../interfaces/itimeline";
/**
 * Filters the events based on all the properties using the value passed in
 * Takes an array of events and a search term
 * Usage:
 *
 * Example:
 *  {{ events | searchTerm:January }}
 */
@Pipe({
    name: "eventfilter",
    standalone: false
})
export class EventFilterPipe implements PipeTransform {
    transform(events: IEvent[], searchTerm: string): any {
        if (searchTerm === null || searchTerm === undefined || searchTerm.length === 0) {
            return events;
        }
        let st: string = searchTerm.toLowerCase();
        let searchList: any = st.split(" ");
        searchList.forEach((s: string) => {
            events = events.filter(
                item => item.country.name.toLowerCase().indexOf(s) > -1 ||
                    item.country.code.toLowerCase().indexOf(s) > -1 ||
                    item.text.toLowerCase().indexOf(s) > -1 ||
                    (item.url != null && item.url.toLowerCase().indexOf(s) > -1) ||
                    moment(item.publishDate).format("DD MMMM YYYY").toLowerCase().indexOf(s) > -1);
        });
        return events;
    }
}